import { useMultiAccounts } from 'contexts/MultiAccounts';
import useMultiAccountNotification from './useMultiAccountNotification';

export default function useFieldMultiAccount(transNamespace) {
  const displayMultiAccountNotification = useMultiAccountNotification(transNamespace);
  const {
    state,
    selectors: { selectMultiAccount },
  } = useMultiAccounts();

  const handleChange = (currentVal, prevVal, shouldDisplayNotification = true) => {
    const selectedAccount = selectMultiAccount(state, currentVal);
    const selectedDebtOwner = selectedAccount ? selectedAccount.debtOwner : 'false';

    if (shouldDisplayNotification) displayNotification(currentVal, prevVal, selectedDebtOwner);
    return selectedDebtOwner;
  };

  const displayNotification = (currentVal, prevVal, currentDebtOwner) => {
    if (currentVal) {
      displayMultiAccountNotification('On', currentDebtOwner);
    } else if (prevVal && !currentVal) {
      displayMultiAccountNotification('Off');
    }
  };

  return {
    handleChange,
  };
}
